/*This component will be about show the user how many token they have left to use*/
import * as React from 'react';
import {useEffect, useState} from "react";
import { useNavigate, useLocation} from 'react-router-dom';
import { CurrencyDollarIcon } from '@heroicons/react/24/outline';
import config from "../config";
import Helper from "../helpers";
import { isPublicRoute } from '../Services/SiteService.ts';

const baseUrl = config.apiBaseUrl;
const TokenCount = (prop) => {
    const  {isLoggedIn} = prop;
    const [loading, setLoading] = useState(true);
    const [userLogin, setUserLogin] = useState(isLoggedIn);
    const [tokenCount, setToeknCount] = useState(0);
    const [userId, setUserId] = useState(null);
    const [userVenueKey, setUserVenueKey] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const fetchToken = async () => {            
            const getUserId = async () => {
                const user = await Helper.getUserId();
                setUserId(user);
            }

            const getUserTokens = async (uvk) => {
                const token = await Helper.getCookie('wh-jwt');
                if(!token){
                    setUserLogin(false);
                    return;
                }
                setUserLogin(true);
                
                await fetch(`${baseUrl}/api/users/token/${uvk}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    credentials: 'include'
                })
                    .then(response =>{
                        if (response.status === 401) {
                            navigate("/login");
                            return Promise.reject("Unauthorized: Redirecting to login");
                          }
                          return response.json();
                    })
                    .then(data => {
                        setToeknCount(data.tokens);
                    })
            };

            const getUserVenueId = async () => {
                const venue = await Helper.getUserVenueId();
                setUserVenueKey(venue);
                await getUserTokens(venue);
            }

            const isCurrentRoutePublic = isPublicRoute(location.pathname);
            if(!isCurrentRoutePublic) {
                await getUserId();
                await getUserVenueId();
            }
            setLoading(false);
        };

        fetchToken();
    }, [isLoggedIn, userId, userVenueKey, navigate, location.pathname]);

    if(userLogin && loading) {
        return (
            <div className="flex justify-center items-center h-16">
                <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-gray-500"></div>
            </div>
        );
    }

    return userLogin && tokenCount ? (
        <div className="card p-4 flex items-center space-x-3">
            <CurrencyDollarIcon className="h-6 w-6 text-yellow-400" />
            <div>
                <div className="text-lg font-bold text-white">{tokenCount}</div>
                <div className="text-sm text-gray-300">Tokens</div>
            </div>
        </div>
    ) : <></>;
}

export default TokenCount;
